import { getApiActionTypes } from '../../../shared/store/storeHelpers';

export const fetchStateAccountNumbersTypes = getApiActionTypes('FETCH_STATE_ACCOUNT_NUMBERS');
export const updateStateAccountNumbersTypes = getApiActionTypes('UPDATE_STATE_ACCOUNT_NUMBERS');
